import moment from "moment";
import { useEffect, useState } from "react";

/* eslint-disable import/extensions */
import { getDiscordMostActiveChannels } from "../../lib/discordQueries";
/* eslint-disable import/extensions */
import { MostActiveChannelsRpc } from "../../lib/discordTypes";

const defaultTimeFormat = "MM/DD/YY";

/**
 * Fetches the 10 most active Discord channels over a period of time
 *
 * @param startTime - start of time period
 * @param endTime - end of time period
 * @param guildId - the guild id
 * @returns - An object with two properties --> data: the 10 most active Discord channels. isLoading: true when fetching data, false when done
 */
const useMostActiveChannels = (
  startTime: string,
  endTime: string,
  guildId: string | null
) => {
  const [mostActiveChannels, setMostActiveChannels] = useState<
    MostActiveChannelsRpc[] | null
  >([]);
  const [loading, setLoading] = useState<boolean>(true);

  /**
   * Fetches the most active Discord channels and sets the isLoading state
   */
  const loadData = async (): Promise<void | null> => {
    setLoading(true);

    const params = {
      start_time: moment(startTime).format(defaultTimeFormat),
      end_time: moment(endTime).format(defaultTimeFormat),
      guild_id: guildId,
    };

    const data = await getDiscordMostActiveChannels(
      params.start_time,
      params.end_time,
      params.guild_id
    );

    setMostActiveChannels(data);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [startTime, endTime]);

  return { data: mostActiveChannels, isLoading: loading };
};

export default useMostActiveChannels;
